module.exports = __webpack_public_path__ + "static/media/PhonePe.31333989.png";